import styled from "styled-components";

export const Content = styled.div`
  width: 100%;
  position: relative;
`;

/* mantive o nome 'luminosity' como você enviou */
export const luminosity = styled.div`
  width: 50vw;
  height: 50vw;
  left: 18%;
  top: 80px;
  opacity: 1;
  filter: blur(120px);

  width: 316px;
  background-color: var(--orange-500);
  position: absolute;
  border-radius: 50%;

  @media (min-width: 800px) {
    width: 316px;
    height: 316px;
    left: 50%;
    top: 230px;
  }

  @media (min-width: 1100px) {
    top: 225px;
    left: 650px;
  }

  @media (min-width: 1240px) {
    left: 750px;
  }
`;

/* === AQUI troquei o pattern das bolinhas para ficar igual ao componente === */
export const Mask = styled.div`
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  isolation: isolate;

  /* mesmas variáveis do componente (pode ajustar se quiser) */
  --gap: 8px;
  --dot-size: 2px;
  --base-dot-opacity: 0.22;
  --mask-soft-vignette: linear-gradient(
    130deg,
    rgba(255, 255, 255, 0.18) 0%,
    rgba(255, 255, 255, 0.08) 40%,
    rgba(255, 255, 255, 0) 85%
  );

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    pointer-events: none;

    /* bolinhas iguais ao componente (brancas com opacidade + vinheta sutil) */
    --dot-color: rgba(255, 255, 255, var(--base-dot-opacity));
    background-image:
      radial-gradient(
        circle at center,
        var(--dot-color) var(--dot-size),
        transparent calc(var(--dot-size) + 0.1px)
      ),
      var(--mask-soft-vignette);
    background-size:
      var(--gap) var(--gap),   /* tile da malha */
      100% 100%;
    background-repeat: repeat, no-repeat;
    background-position: 0 0, 0 0;

    /* mantém teu fade nas bordas */
    -webkit-mask-image: radial-gradient(
      circle at center,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 0) 60%
    );
    mask-image: radial-gradient(
      circle at center,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 0) 60%
    );
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;

    /* se quiser acender sobre fundo escuro:
       mix-blend-mode: screen; */
  }
`;

export const MaskLeft = styled(Mask)`
  width: 100%;
  height: 850px;
  border-radius: 0;
  top: 200px;
  border-top-left-radius: 300px;
  border-top-right-radius: 300px;    /* corrigido (negativo é inválido) */
  border-bottom-left-radius: 300px;
  border-bottom-right-radius: 300px;

  @media (min-width: 1100px) {
    top: 250px;
    left: -100px;
    width: 650px;
    height: 650px;
    border-radius: 50%;
  }
`;

export const MaskCenter = styled(Mask)`
  top: 330px;
  left: 650px;
  width: 316px;
  height: 316px;
  display: none;

  @media (min-width: 1100px) {
    display: block;
  }

  @media (min-width: 1240px) {
    top: 350px;
    left: 750px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  max-width: 1440px;
  width: 100%;
  padding: 40px 16px;
  margin: 0 auto;
  margin-top: -1px;
  position: relative;

  @media (min-width: 1200px) {
    padding: 40px 120px;
  }
`;

export const WrapperFlex = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  @media (min-width: 800px) {
    flex-direction: row-reverse;
  }

  @media (min-width: 1020px) {
    gap: 48px;
  }
`;

export const HeroImgComp = styled.img`
  width: 240px;
  z-index: 2;

  @media (min-width: 500px) {
    width: 430px;
  }

  @media (min-width: 1240px) {
    width: 580px;
  }
`;

export const TextBox = styled.div`
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (min-width: 768px) {
    gap: 48px;
    justify-content: space-between;
  }
`;

export const Title = styled.h1`
font-weight: 600;
font-style: Bold;
font-size: 30px;
line-height: 40px;
letter-spacing: 1px;


  @media (min-width: 700px) {
    font-size: 42px;
    line-height: 52px;
    letter-spacing: 1px;
  }

  @media (min-width: 1020px) {
    font-size: 56px;
    line-height: 64px;
    letter-spacing: 2px;
  }
`;

export const Text = styled.p`
  font-size: 16px;
  font-style: normal;
  font-weight: 325;
  line-height: 24px;

  @media (min-width: 700px) {
    font-size: 18px;
    font-style: normal;
    font-weight: 325;
    line-height: 28px;
  }

  @media (min-width: 1020px) {
    font-size: 20px;
    font-style: normal;
    font-weight: 325;
    line-height: 28px;
  }
`;

export const ActionBtn = styled.button`
  color: var(--orange-500);
  border: 1px solid var(--orange-500);
  width: 100%;
  margin: 0 auto;

  @media (min-width: 800px) {
    margin: 0;
    width: 294px;
  }
`;

export const NavigationBtn = styled.button`
  font-size: 16px;
  font-style: normal;
  font-weight: 550;
  line-height: 24px;
  display: none;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;

  @media (min-width: 1020px) {
    display: flex;
  }
`;
